import { useState } from 'react';
import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';
import { X } from 'lucide-react';
import { useSubscription } from '../../../hooks/useSubscription';

export function NudgeBanner() {
  const { t } = useTranslation('billing');
  const { data } = useSubscription();
  const nudge = data?.nudge ?? null;
  const dismissKey = nudge ? `nudge-dismissed:${nudge.kind}:${nudge.dueAt}` : '';
  const [dismissed, setDismissed] = useState(
    () => !!nudge && typeof window !== 'undefined' && localStorage.getItem(dismissKey) === '1',
  );
  if (!nudge || dismissed) return null;

  const planName = data?.plan.name ?? '';
  const days = nudge.daysLeft;
  const tone =
    nudge.kind === 'RENEWAL_DUE'
      ? 'bg-amber-50 border-amber-200 text-amber-800'
      : 'bg-red-50 border-red-200 text-red-800';

  const targetId = data?.pendingInvoice?.id ?? null;
  const ctaTo = targetId ? `/billing/invoices/${targetId}` : `/billing`;

  return (
    <div className={`flex items-center justify-between gap-3 border-b px-5 py-2 text-[13px] ${tone}`}>
      <div className="flex-1">
        <span className="font-semibold mr-2">{t(`nudge.${nudge.kind}.title`)}</span>
        <span>{t(`nudge.${nudge.kind}.body`, { plan: planName, days })}</span>
      </div>
      <Link to={ctaTo} className="font-semibold underline">
        {t(`nudge.${nudge.kind}.cta`)}
      </Link>
      <button
        type="button"
        onClick={() => {
          localStorage.setItem(dismissKey, '1');
          setDismissed(true);
        }}
        className="opacity-60 hover:opacity-100"
        aria-label={t('nudge.dismiss')}
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
